import { Container, Col, Picture, Row, Typography } from 'darrius';

import styles from './HomeCounting.module.scss';

export const HomeCounting = () => {
  return (
    <Container className={styles['home-counting']} as="section">
      <Row
        className={`${styles['home-counting__section']} statistics middle-md`}
      >
        <Col className="col-sm-12 center-sm col-md-4 col-lg-5">
          <Row className="space-between">
            <Col className="col-sm-12 center-sm">
              <div className={styles['home-counting__content']}>
                <div className={styles.highlight}>
                  <Typography.Title className={styles.title} size="3xl" as="h5">
                    4.000.000
                  </Typography.Title>
                </div>
                <Typography.Text className={styles.text}>
                  De serviços solicitados no ano de 2020 na plataforma do
                  GetNinjas
                </Typography.Text>
              </div>

              <div className={styles['home-counting__content']}>
                <div className={styles.highlight}>
                  <Typography.Title className={styles.title} size="3xl" as="h5">
                    140.000
                  </Typography.Title>
                </div>

                <Typography.Text className={styles.text}>
                  Clientes felizes por mês, com serviços contratados pelo
                  GetNinjas.
                </Typography.Text>
              </div>

              <div className={styles['home-counting__content']}>
                <div className={styles.highlight}>
                  <Typography.Title className={styles.title} size="3xl" as="h5">
                    R$ 960.000.000
                  </Typography.Title>
                </div>
                <Typography.Text className={styles.text}>
                  Valor em serviços por ano, no bolso dos nossos profissionais.
                </Typography.Text>
              </div>
            </Col>
          </Row>
        </Col>
        <Col className="col-sm-12 center-sm col-md-8 col-lg-6 col-lg-offset-1">
          <Picture
            className="full"
            alt="Mapa"
            src={{
              sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/Mapa.png`,
              md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/Mapadesk.png`,
              lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/Mapadesk.png`,
            }}
            size={{
              sm: {
                width: 328,
                height: 338,
              },
              md: {
                width: 567,
                height: 578,
              },
              lg: {
                width: 567,
                height: 578,
              },
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default HomeCounting;
